export default __webpack_public_path__ + "static/anastasia-zhenina-binding-ca66610f37ddeff104f13e97a9612fb3.jpg";